import { Card, CardBody, Col } from "reactstrap";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AutoPlayVariants } from "../../../../Constant";
import { AUTO_PLAY, AUTO_PLAY_DATA } from "../../../../Data/Bonus Ui/Carousel";

const AutoPlayVariant = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={AutoPlayVariants} span={AUTO_PLAY} />
        <CardBody>
          <Swiper slidesPerView={1} autoplay={{ delay: 2500, disableOnInteraction: false }} pagination={{ clickable: true }} modules={[Autoplay, Pagination]} className="mySwiper swiper-h">
            {AUTO_PLAY_DATA.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={item.image} className="d-block w-100" alt="Vertical_Slider" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AutoPlayVariant;
